import styled from '@emotion/styled/macro'
import { size } from '@styles/theme'
import { Switch } from './Switch'


const SwitchLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  padding: ${size(2)} ${size(1)} ${size(2)} ${size(2)};
`

const LabelText = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  font-weight: 500;
`

const FullLengthSwitch = ({ label, labelIcon, ...rest }) => {
  return (
    <SwitchLabel>
      <LabelText>{labelIcon && <>{labelIcon()}&nbsp;&nbsp;</>}{label}</LabelText>
      <Switch {...rest} />
    </SwitchLabel>
  )
}

export { FullLengthSwitch }
